import { createSlice } from "@reduxjs/toolkit";
import { getOpsDashboardStatsThunk } from "../thunk/opsDashboardThunk";

interface stateType{
    dashboardStatsData:any
}

const initialState:stateType={
    dashboardStatsData:{}
}

const opsDashboardSlice=createSlice({
    name:'opsDashboardSlice',
    initialState,
    reducers:{},
    extraReducers: (builder: any) => {
    builder.addCase(
        getOpsDashboardStatsThunk.fulfilled,
        (state: any, action: any) => {
            state.dashboardStatsData=action.payload
        }
    )
  }
})

export default opsDashboardSlice.reducer;
